import clsx from "clsx";
import React from "react";
import { Form, InputGroup } from "react-bootstrap";
import Image from "react-bootstrap/Image";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye, faEyeSlash, faLock } from "@fortawesome/free-solid-svg-icons";
import * as axiosInstance from "../../services/axiosInstance";
import _ from "lodash";
import { useForm } from "react-hook-form";
import PAGE from "../../utils/Destination";
import * as authSelectors from "../../selectors/auth";
import LoadingOverlay from "../../components/LoadingOverlay";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import * as CryptoHelper from "../../utils/CryptoHelper";

function NewPassword({ history }) {
  const [loading, setLoading] = React.useState(false);
  const [passwordView, setPasswordView] = React.useState(false);
  const [confirmPasswordView, setConfirmPasswordView] = React.useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
    setValue,
  } = useForm();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const emailURL = queryParams.get("email");
  const userName = queryParams.get("username");
  const tokenURL = queryParams.get("token");
  // const onSubmit = (e) => {
  //     e.preventDefault();
  //     history.push("/auth/password-changed")
  // };

  useEffect(() => {
    setValue("email", emailURL);
    setValue("username", userName);
  }, [emailURL, userName]);

  const onSubmit = async (values) => {
    const { username } = values;
    // const decodedEmail = decodeURIComponent(email);
    const updatedValues = {
      ...values,
      token: tokenURL,
    };

    setLoading(true);
    try {
      const encrytionResult = await axiosInstance.post(
        "/clientarea/encryption/create",
        {},
        false,
        false,
        "",
        {},
        true,
      );
      const result = _.get(encrytionResult, ["data"], null);
      const encryptedKey = CryptoHelper.decryptData(
        result.key,
        result.salt,
        result.iv,
        process.env.REACT_APP_PASSPHRASE,
      );
      const encryptedPassword = CryptoHelper.encryptData(
        values.password,
        result.salt,
        result.iv,
        encryptedKey,
      );
      const encryptedPasswordConfirmation = CryptoHelper.encryptData(
        values.password_confirmation,
        result.salt,
        result.iv,
        encryptedKey,
      );
      const newUpdatedValues = {
        ...updatedValues,
        username: username.toUpperCase(),
        password: encryptedPassword,
        password_confirmation: encryptedPasswordConfirmation,
        encryption_id: result.id,
      };
      axiosInstance
        .post("clientarea/auth/reset-password", newUpdatedValues, true, false)
        .then((response) => {
          const token = authSelectors.getAuthToken(response);
          navigateToNewPass();
        })
        .catch((error) => {
          // Handle errors here if needed
        })
        .finally(() => {
          setLoading(false);
        });
    } catch (e) {
      console.log(e);
    }
  };

  const navigateToNewPass = () => {
    // setLoading(true);
    history.push(PAGE.PASSWORD_CHANGED);
  };
  const onclickBackToLogin = () => {
    history.push(PAGE.LOGIN);
  };

  return (
    <div className="col-xxl-4 col-lg-5 col-md-7">
      <div className="card">
        <div className="card-header pt-4 pb-4 text-center">
          <span>
            <Image
              src="/img/ta-securities-logo.png"
              style={{ height: "55px", width: "auto" }}
            />
          </span>
        </div>
        <div className="card-body">
          <div className="text-center w-75 m-auto">
            <FontAwesomeIcon
              icon={faLock}
              style={{ color: "#9D7905", fontSize: "20px", margin: "15px 0" }}
            />

            <h4 className="text-dark-50 text-center mt-0 font-weight-bold title">
              Set New Password
            </h4>
          </div>

          <Form onSubmit={handleSubmit(onSubmit)} className="w-100 mt-3">
            <Form.Group className="mb-3">
              <div className="d-flex justify-content-between">
                <Form.Label className="formLabel required">Username</Form.Label>
                <a
                    href={PAGE.FAQ}
                    className="gridLink"
                    style={{fontSize: "0.65rem", textAlign: "center", justifyContent: "center"}}
                    target="_blank"
                >
                  <span>FAQ</span>
                </a>
              </div>
              <Form.Control
                  isInvalid={!_.isEmpty(errors && errors.username)}
                  className="formControl auto-uppercase"
                  name="username"
                  placeholder="Enter your client code"
                  defaultValue={userName}
                  disabled
                  {...register("username", {required: "Client code is required"})}
              />
                {errors.username && (
                    <Form.Control.Feedback type="invalid">
                      {errors.username.message}
                    </Form.Control.Feedback>
                )}
            </Form.Group>
            <Form.Group className="mb-3">
            <Form.Label className="formLabel required">
                Email Address
              </Form.Label>
              <Form.Control
                isInvalid={!_.isEmpty(errors && errors.email)}
                className="formControl"
                name="email"
                type="email"
                placeholder="Enter your email"
                defaultValue={emailURL}
                disabled
                {...register("email", {
                  required: "Email address is required",
                })}
              />
              {errors.email && (
                <Form.Control.Feedback type="invalid">
                  {errors.email.message}
                </Form.Control.Feedback>
              )}
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label className="formLabel required">
                New Password
              </Form.Label>
              <InputGroup className="mb-3">
                <Form.Control
                  className="formControl"
                  isInvalid={!_.isEmpty(errors && errors.password)}
                  type={passwordView ? "input" : "password"}
                  placeholder="Enter your password"
                  name="password"
                  {...register("password", {
                    required: "Please enter your password",
                  })}
                />
                <InputGroup.Text id="basic-addon1">
                  <FontAwesomeIcon
                    onClick={() => setPasswordView((prevState) => !prevState)}
                    className="password-icon"
                    icon={passwordView ? faEyeSlash : faEye}
                    color="#666666"
                  />
                </InputGroup.Text>
                {errors.password && (
                  <Form.Control.Feedback type="invalid">
                    {errors.password.message}
                  </Form.Control.Feedback>
                )}
              </InputGroup>
            </Form.Group>
            <Form.Group className="mb-3">
              <Form.Label className="formLabel required">
                Confirm New Password
              </Form.Label>
              <InputGroup>
                <Form.Control
                  className="formControl"
                  isInvalid={!_.isEmpty(errors && errors.password_confirmation)}
                  type={confirmPasswordView ? "input" : "password"}
                  placeholder="Confirm New Password"
                  name="password_confirmation"
                  {...register("password_confirmation", {
                    required: "Please enter your password",
                  })}
                />
                <InputGroup.Text id="basic-addon1">
                  <FontAwesomeIcon
                    onClick={() =>
                      setConfirmPasswordView((prevState) => !prevState)
                    }
                    className="password-icon"
                    icon={confirmPasswordView ? faEyeSlash : faEye}
                    color="#666666"
                  />
                </InputGroup.Text>
                {errors.password_confirmation && (
                  <Form.Control.Feedback type="invalid">
                    {errors.password_confirmation.message}
                  </Form.Control.Feedback>
                )}
              </InputGroup>
            </Form.Group>
            <div className="text-center">
              <button
                className={clsx("btn btn-primary btn-fill mt-2 mb-4")}
                type="submit"
              >
                Confirm
              </button>
            </div>
          </Form>
        </div>
        <LoadingOverlay loading={loading}></LoadingOverlay>
      </div>

      <div className="row mt-3">
        <div className="col-12 text-center">
          <p className="text-black-50">
            Back to{" "}
            <a href="/" onClick={onclickBackToLogin} className="ms-1">
              <b>Log In</b>
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}

export default NewPassword;
